import {Component, Input} from '@angular/core';
import {User} from '@spartacus/core';

@Component({
  selector: 'dcp-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {
  private _user: User;
  @Input() set user(value: User) {
    this._user = value;
    this.setUserAddress(value);
  }

  get user(): User {
    return this._user;
  }

  public userAddress: string;


  setUserAddress(value: User) {
    this.userAddress = value?.email ? value.email : value?.defaultAddress?.email;
  }
}
